import FormattedMessage from 'I18n/components/FormattedMessage';
import { ButtonGroup } from 'foundations-components/transitional/components/ButtonGroup';
import { Button } from 'foundations-components/transitional/components/Button';
import { jsx as _jsx } from "react/jsx-runtime";
export const START_MODE_OPTIONS = [{
  textKey: 'automation.testV2.simulatePanel.startMode.AUTOMATIC',
  value: 'DYNAMIC'
}, {
  textKey: 'automation.testV2.simulatePanel.startMode.MANUAL',
  value: 'MANUAL'
}];
const StartModeViewController = ({
  value,
  onChange
}) => {
  return (
    /*#__PURE__*/
    /* Cant pass flex-grow-1 through available props, so we have to build our own UIViewController and use the private class for the styles */
    _jsx(ButtonGroup, {
      role: "radiogroup",
      display: "flex",
      children: START_MODE_OPTIONS.map(option => {
        const isActive = option.value === value;
        return /*#__PURE__*/_jsx(Button
        /* eslint-disable-next-line */, {
          active: isActive,
          "aria-checked": isActive,
          onClick: () => {
            onChange(option);
          },
          responsive: false,
          role: "radio",
          size: "small",
          use: "tertiary-light",
          block: true,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: option.textKey
          })
        }, option.value);
      })
    })
  );
};
export default StartModeViewController;